// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trackersBlock__yYx5Q {
  padding: 25px 25px 0;
}
@media (max-width: 1100px) {
  .trackersBlock__yYx5Q {
    padding: 15px 15px 0;
  }
}

.trackersBlockHead__opC_K {
  padding: 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--tables-primary-row-surface-default);
  border: 1px solid var(--header-stroke);
  border-bottom: unset;
}

.trackersBlockHeadTitle__InVyB {
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  color: var(--header-title-main);
  text-transform: uppercase;
  display: flex;
  align-items: center;
  column-gap: 15px;
  white-space: nowrap;
}

.addIcon__RCOMN path {
  fill: var(--buttons-text-secondary);
}

.tableWrapper__XYOP8 {
  max-height: 495px;
  overflow-y: auto;
}
.tableWrapper__XYOP8::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.tableWrapper__XYOP8::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.tableWrapper__XYOP8::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.tableWrapper__XYOP8::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}

.trackersTable__q1lwQ {
  width: 100%;
  background: var(--tables-primary-row-surface-default);
  border: 1px solid var(--header-stroke);
  border-bottom: unset;
}

.trackersTableTh__fToCN {
  font-size: 11px;
  font-weight: 400;
  line-height: 14px;
  color: var(--tables-secondary-row-sub-title-text);
  text-transform: uppercase;
  text-align: left;
  padding: 16px 15px;
  background: var(--tables-title-surface);
  position: sticky;
  top: 0;
}

.sortIcon__AXtl9 {
  margin-left: 5px;
  cursor: pointer;
  outline: none;
}

.trackersTableBodyRow__MFqzJ:hover {
  background: var(--tables-primary-row-surface-hover);
}

.trackersTableTd__NaeBy {
  padding: 10px 15px;
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  color: var(--tables-secondary-row-sub-title-text);
  font-size: 11px;
  font-style: normal;
  font-weight: 600;
  line-height: 12px;
}
.trackersTableTd__NaeBy:first-child {
  padding-left: 25px;
}

.actionsIconContainer__lTuMx {
  width: 35px;
  cursor: pointer;
}

.skeletonText__OE2CN {
  height: 24px;
}

.trackersSearchBlock__uHEWS {
  min-width: 205px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/GPSAssetTracking/components/GpsTrackersBlock/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,oBAAA;AAzEF;AA0EE;EAFF;IAGI,oBAAA;EAvEF;AACF;;AA0EA;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qDAAA;EACA,sCAAA;EACA,oBAAA;AAvEF;;AA0EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,+BAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAvEF;;AA2EE;EACE,mCAAA;AAxEJ;;AA4EA;EACE,iBAAA;EACA,gBAAA;AAzEF;AAZE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAcJ;AAXE;EACE,+BAAA;EACA,kBAAA;AAaJ;AAVE;EACE,8BAAA;EACA,kBAAA;AAYJ;AATE;EACE,gBAAA;EACA,kBAAA;AAWJ;;AA6DA;EACE,WAAA;EACA,qDAAA;EACA,sCAAA;EACA,oBAAA;AA1DF;;AA6DA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iDAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,uCAAA;EAEA,gBAAA;EACA,MAAA;AA3DF;;AA8DA;EACE,gBAAA;EACA,eAAA;EACA,aAAA;AA3DF;;AA+DE;EACE,mDAAA;AA5DJ;;AAgEA;EACE,kBAAA;EACA,yDAAA;EACA,iDAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AA7DF;AA+DE;EACE,kBAAA;AA7DJ;;AAiEA;EACE,WAAA;EACA,eAAA;AA9DF;;AAiEA;EACE,YAAA;AA9DF;;AAiEA;EACE,gBAAA;AA9DF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.trackersBlock {\n  padding: 25px 25px 0;\n  @media (max-width: 1100px) {\n    padding: 15px 15px 0;\n  }\n}\n\n.trackersBlockHead {\n  padding: 25px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: var(--tables-primary-row-surface-default);\n  border: 1px solid var(--header-stroke);\n  border-bottom: unset;\n}\n\n.trackersBlockHeadTitle {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 17px;\n  color: var(--header-title-main);\n  text-transform: uppercase;\n  display: flex;\n  align-items: center;\n  column-gap: 15px;\n  white-space: nowrap;\n}\n\n.addIcon {\n  path {\n    fill: var(--buttons-text-secondary);\n  }\n}\n\n.tableWrapper {\n  max-height: 495px;\n  overflow-y: auto;\n\n  @include scrollBar;\n}\n\n.trackersTable {\n  width: 100%;\n  background: var(--tables-primary-row-surface-default);\n  border: 1px solid var(--header-stroke);\n  border-bottom: unset;\n}\n\n.trackersTableTh {\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 14px;\n  color: var(--tables-secondary-row-sub-title-text);\n  text-transform: uppercase;\n  text-align: left;\n  padding: 16px 15px;\n  background: var(--tables-title-surface);\n\n  position: sticky;\n  top: 0;\n}\n\n.sortIcon {\n  margin-left: 5px;\n  cursor: pointer;\n  outline: none;\n}\n\n.trackersTableBodyRow {\n  &:hover {\n    background: var(--tables-primary-row-surface-hover);\n  }\n}\n\n.trackersTableTd {\n  padding: 10px 15px;\n  border-bottom: 1px solid var(--tables-primary-row-stroke);\n  color: var(--tables-secondary-row-sub-title-text);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 12px;\n\n  &:first-child {\n    padding-left: 25px;\n  }\n}\n\n.actionsIconContainer {\n  width: 35px;\n  cursor: pointer;\n}\n\n.skeletonText {\n  height: 24px;\n}\n\n.trackersSearchBlock {\n  min-width: 205px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"trackersBlock": `trackersBlock__yYx5Q`,
	"trackersBlockHead": `trackersBlockHead__opC_K`,
	"trackersBlockHeadTitle": `trackersBlockHeadTitle__InVyB`,
	"addIcon": `addIcon__RCOMN`,
	"tableWrapper": `tableWrapper__XYOP8`,
	"trackersTable": `trackersTable__q1lwQ`,
	"trackersTableTh": `trackersTableTh__fToCN`,
	"sortIcon": `sortIcon__AXtl9`,
	"trackersTableBodyRow": `trackersTableBodyRow__MFqzJ`,
	"trackersTableTd": `trackersTableTd__NaeBy`,
	"actionsIconContainer": `actionsIconContainer__lTuMx`,
	"skeletonText": `skeletonText__OE2CN`,
	"trackersSearchBlock": `trackersSearchBlock__uHEWS`
};
module.exports = ___CSS_LOADER_EXPORT___;
